export default __webpack_public_path__ + "static/media/white_back_arrowa.62c1972b.svg";